<h3>Email <button (click)="sendEmail()" class="btn btn-success btn-sm ml-3">Compose</button></h3>

<ag-grid-angular style="width: 100%;" class="ag-theme-bootstrap mt-3" [gridOptions]="gridOptions"
            [rowData]="rowData" [columnDefs]="columnDefs" animateRows pagination=false paginationPageSize=5 rowHeight=27
            headerHeight=35 domLayout='autoHeight' (rowClicked)='onGridRowClicked($event)'> </ag-grid-angular>
 